import { addProtocolIfNeed } from '@/utils/utils'

export const prepareUrl = (url: string): string => {
  const urlWithProtocol = addProtocolIfNeed(url)
  if (urlWithProtocol.endsWith('/')) {
    return urlWithProtocol.slice(0, -1)
  }
  return urlWithProtocol
}
